export default __webpack_public_path__ + "static/media/main.8c44e136.png";